<template>
  <div>
    <b-overlay :show="overlay">
      <b-card no-body class="mb-0">
        <div class="m-2">
          <p class="mb-1">Para dar descontos conforme a quantidade comprada, clique em <strong>Configurar preço e faixas</strong> no produto. Quantidade e saldo são o controle de uso da promoção.</p>
          <!-- Filtro Superior -->
          <b-row>
            <!-- Opções de Página -->
            <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>Mostrar</label>
              <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
                :clearable="false" class="per-page-selector d-inline-block mx-50" />
              <label>entradas</label>
            </b-col>

            <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input v-model="searchQuery" class="d-inline-block mr-1"
                  placeholder="Pesquisar pela descrição" />
                <b-button v-if="isEditAllowed" variant="primary" v-b-modal.modal-buscar-itens-pic
                  @click="showModal, resetFormData">
                  <div class="d-flex" style="gap: 5px">
                    <iconfy icon="mdi:plus" />
                    <span>Adicionar produto</span>
                  </div>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>

        <!-- Tabela -->
        <b-table ref="refPicItemListTable" class="position-relative" :items="fetchPicItem" responsive stacked="md"
          :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty
          empty-text="Nenhum registro encontrado" :sort-desc.sync="isSortDirDesc">
          <template #cell(picitemfaixas)="data">
            <div v-if="faixasDoItem(data.item).length" class="text-nowrap">
              <div v-for="(faixa, index) in faixasDoItem(data.item)" :key="index">
                <strong>{{ faixa.min }}{{ faixa.max === null ? '+' : `–${faixa.max}` }} un.</strong>
                — {{ faixa.desconto }}%
              </div>
            </div>
            <span v-else class="text-muted">Sem faixas (preço fixo)</span>
          </template>
          <template #cell(picitemporcentagem)="data">
            <span>{{ faixasDoItem(data.item).length ? 'Por faixa' : `${data.item.picitemporcentagem || 0}%` }}</span>
          </template>
          <template #cell(actions)="data">
            <div>
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-primary" class="mr-1 text-nowrap"
                @click="openEditModal(data.item)">
                {{ isEditAllowed ? 'Configurar preço e faixas' : 'Ver preço e faixas' }}
              </b-button>

              <b-button v-if="isEditAllowed" variant="gradient-danger" class="btn-icon"
                @click="openModalDeleteCustomField(data.item)">
                <feather-icon icon="TrashIcon" />
              </b-button>
            </div>
          </template>
        </b-table>

        <!-- Paginação -->
        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">
                Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} entradas
              </span>
            </b-col>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage" :total-rows="totalPicItem" :per-page="perPage" first-number
                last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>

    <!-- Modais -->
    <ModalAtt idModal="modal-att-pic-item" titleModal="Preço e faixas do produto" :labelBtnOk="'Salvar'" v-model="dataPicItem"
      :picsituacao="picsituacao" @ok="handleModalUpdate" @cancel="resetFormData()" />

    <item-modal :items="dataFromApiitem" :picid="picidbusca" :tabelaprecoid="tabelaprecoid"
      @ok="refreshTable" ref="itemModal" />

    <modal-confirmation v-model="isDeleteModal" id-modal="modal-delete-pic-item" title="Deletar Item"
      btn-cancel-label="Cancelar" btn-ok-label="Sim, deletar" @ok="handleRemover(deletedCustomField)"
      @cancel="resetFormData()">
      <template #message>
        <div>
          <p>Tem certeza que deseja deletar esse item da pic?</p>
        </div>
      </template>
    </modal-confirmation>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import {
  BButton, BCard, BTable, BRow, BCol, BPagination, BFormInput,
} from 'bootstrap-vue';
import ModalConfirmation from '@/components/ModalConfirmation.vue';
import ItemModal from '@/views/app/operacoes/picitem/list/ModalBuscarItens.vue';
import axios from '@/libs/axios';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { avatarText } from '@core/utils/filter';
import ModalAtt from './ModalAtt.vue';
import useList from './useList';

export default {
  components: {
    ItemModal,
    ModalAtt,
    ModalConfirmation,
    BButton,
    BCard,
    BTable,
    BRow,
    BCol,
    BPagination,
    BFormInput,
  },
  props: {
    picidbusca: {
      type: Number,
      required: true,
    },
    picsituacao: {
      type: String,
      required: true,
    },
    tabelaprecoid: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      isDeleteModal: false,
      dataFromApiitem: [],
      deletedCustomField: this.resetDeletedField(),
      dataPicItem: this.resetDeletedField(),
    };
  },
  computed: {
    isEditAllowed() {
      return this.picsituacao !== 'Aprovada' && this.picsituacao !== 'Pendente';
    },
  },
  methods: {
    faixasDoItem(item) {
      if (Array.isArray(item.picitemfaixas)) return item.picitemfaixas;
      try { return JSON.parse(item.picitemfaixas || '[]'); } catch (_) { return []; }
    },
    async fetchDataFromitem() {
      try {
        const response = await axios.get('/tabela-preco-item/findAllById');
        this.dataFromApiitem = response.data.data.map((item) => ({
          value: item.item?.item_id,
          text: `${item.item?.item_id} - ${item.item?.item_descricao}`,
          referencia: item.item?.familia_comercial_id,
          cod_categoria: item.item?.cod_categ,
          cod_marca: item.item?.familia_comercial?.cod_marca,
        }));
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    showModal() {
      this.$refs.itemModal.show();
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value);
    },
    handleRemover(body) {
      this.removerData(body);
      this.showSuccessToast('Pic Item deletado com sucesso');
      this.isDeleteModal = false;
    },
    openModalDeleteCustomField(data) {
      this.deletedCustomField = data;
      this.isDeleteModal = true;
    },
    openEditModal(data) {
      this.dataPicItem = { ...data, picitemfaixas: this.faixasDoItem(data).map(row => ({ ...row })) };
      // Wait for the child prop update before its show handler reads the tiers.
      this.$nextTick(() => this.$bvModal.show('modal-att-pic-item'));
    },
    handleModalUpdate() {
      this.refreshTable();
    },
    refreshTable() {
      if (this.$refs.refPicItemListTable) {
        this.$refs.refPicItemListTable.refresh();
      }
    },
    resetFormData() {
      this.dataPicItem = this.resetDeletedField();
      this.isDeleteModal = false;
    },
    resetDeletedField() {
      return {
        itemid: '',
        picitemsequencia: '',
        picitemquantidade: '',
        picitemquantidadesaldo: '',
        picitemvalorpic: '',
        picitemtotalmercadoria: '',
        picitemsituacao: 'Pendente',
      };
    },
    showSuccessToast(message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: message,
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
    },
  },
  mounted() {
    this.fetchDataFromitem();
    this.idpic = this.picidbusca;
  },
  setup() {
    const customFields = ref([]);
    const dataPic = ref({
      picid: null,
      picdescricao: '',
      tipopicinformavalorbrutoliquido: '',
      tipopictipocontrole: '',
    });
    // 'VARCHAR', 'INTEGER', 'TIMESTAMP', 'BOOLEAN', 'DATETIME', 'DATE', 'ENUM_OPTIONS', 'TEXT'
    const typeOptionsCustomFields = ref([
      { label: 'Texto', value: 'VARCHAR' },
      { label: 'Númerico', value: 'INTEGER' },
      { label: 'Monetário', value: 'DECIMAL' },
      { label: 'Data', value: 'DATE' },
      { label: 'Data e hora', value: 'DATETIME' },
      { label: 'Texto Longo', value: 'TEXT' },
    ]);
    const currentTab = ref(0);
    const spanderAll = ref(false);

    const headerCustomFields = [
      { key: 'id', label: '' },
      { key: 'label', label: 'Nome' },
      { key: 'quality_rules', label: 'Regras de qualidade' },
      { key: 'actions', label: 'Ações' },
    ];
    const customFieldsOptions = [
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
    ];

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ];

    const statusOptions = [
      { label: 'Pending', value: 'pending' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ];

    const {
      perPage,
      currentPage,
      totalPicItem,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      tableColumns,
      refPicItemListTable,
      fetchPicItem,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      overlay,
      idpic,
      create,
      Updated,
      isLoading,
      removerData,
    } = useList();

    return {
      // Filter
      avatarText,
      planOptions,
      statusOptions,
      headerCustomFields,
      customFieldsOptions,
      spanderAll,
      isLoading,
      currentTab,
      dataPic,
      typeOptionsCustomFields,
      customFields,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      perPage,
      overlay,
      idpic,
      currentPage,
      totalPicItem,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      fetchPicItem,
      tableColumns,
      refPicItemListTable,
      create,
      Updated,
      removerData,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.bg-header-collapse {
  background: #f0f2f5;
}
</style>
